import { render, staticRenderFns } from "./DocTag.vue?vue&type=template&id=72df99d2&scoped=true&"
import script from "./DocTag.vue?vue&type=script&lang=js&"
export * from "./DocTag.vue?vue&type=script&lang=js&"
import style0 from "./DocTag.vue?vue&type=style&index=0&id=72df99d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df99d2",
  null
  
)

export default component.exports